import React from 'react';
import { highlightParts } from './sessionsUtils';

/** Text with the current search words wrapped in <mark>. */
export default function Highlight({ text, q }) {
  const parts = highlightParts(text, q);
  if (parts.length === 1 && !parts[0].hit) return parts[0].text;
  // Parts are derived from the text itself, so their position is a stable key.
  return parts.map((p, i) => (p.hit
    ? <mark key={i} className="ses__mark">{p.text}</mark>
    : <React.Fragment key={i}>{p.text}</React.Fragment>));
}
